<span class="p-paginator-current">
  {{(page.number * page.size) + page.numberOfElements}} {{paginationText}} {{page.totalElements}}
</span>